export const IST_TZ = "Asia/Kolkata";
export const IST_LONG = "India Standard Time (IST)";

const dateOpts = { timeZone: IST_TZ, weekday: "short", day: "numeric", month: "short", hour: "numeric", minute: "2-digit", hour12: true };

export const fmtIST = (iso, long = false) => (iso ? `${new Date(iso).toLocaleString("en-IN", dateOpts).replace(/\s?(am|pm)$/i, (m) => m.toUpperCase())} ${long ? IST_LONG : "IST"}` : "");

export const fmtClock = (hhmm) => {
  if (!hhmm) return "";
  const [h, m] = hhmm.split(":").map(Number);
  const ap = h >= 12 ? "PM" : "AM";
  return `${h % 12 || 12}${m ? `:${String(m).padStart(2, "0")}` : ""} ${ap}`;
};

export const visitorTZ = () => { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ""; } catch { return ""; } };

export const localEquivalent = (iso) => {
  const tz = visitorTZ();
  if (!iso || !tz || tz === IST_TZ) return null;
  const txt = new Date(iso).toLocaleString("en-IN", { ...dateOpts, timeZone: tz }).replace(/\s?(am|pm)$/i, (m) => m.toUpperCase());
  return `${txt} in your local time (${tz.replace(/_/g, " ")})`;
};

export const humanRemaining = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
  const parts = [];
  if (d) parts.push(`${d} day${d > 1 ? "s" : ""}`);
  if (h) parts.push(`${h} hour${h > 1 ? "s" : ""}`);
  if (m || parts.length === 0) parts.push(`${m} minute${m === 1 ? "" : "s"}`);
  return parts.slice(0, 2).join(", ");
};
